<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      税理士事務所共通ヘッダ                                                                                          _/
        _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <HeaderNav menuflg="1" />
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      画面定義                                                                                                      _/
           _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="body">
      <div class="inner">
        <div class="pankuzu">
          <ul>
            <li>
              <router-link class="ico-home" :to="{ name: 'STFMFM01C01' }"
                >メインページ</router-link
              >
            </li>
            <li>
              <span class="current">事業者情報</span>
            </li>
          </ul>
        </div>
        <h1 class="h1">事業者情報</h1>
        <!-- ****  メッセージ表示領域 **** -->
        <div class="frm-row">
          <div class="frm-item grow left">
            <p class="errMsg title-ico ico-warning" v-show="errors != ''">
              <ErrorMessage :errors="errors"></ErrorMessage>
            </p>
          </div>
        </div>

        <p class="lead">書類の収集先となる事業者を登録します。</p>
        <div class="para">
          <!-- ******************************************************************
                 *  上部ボタン群                                                  *
          ******************************************************************-->
          <div class="frm-btn-row">
            <div class="frm-item grow left">
              <button
                class="frm-btn ico ico-plus strong large"
                type="button"
                @click="handleNewAdd"
                ref="newAddButton"
              >
                事業者の新規登録
              </button>
            </div>
            <div class="frm-item grow right import-menu">
              <button class="import-btn" type="button">
                インポート
                <div class="import-menu-nav">
                  <ul>
                    <li>
                      <a type="link" @click="handleTatsuzinImportDialog"
                        >「データ管理の達人」からのインポート</a
                      >
                    </li>
                    <li>
                      <a type="link" @click="handleImportDialog"
                        >ファイルからのインポート</a
                      >
                    </li>
                  </ul>
                </div>
              </button>
              <button
                class="frm-btn ico ico-export"
                type="button"
                @click="handleExportDialog"
              >
                エクスポート
              </button>
            </div>
          </div>
          <!-- ******************************************************************
                 *  フィルタ条件                                                  *
          ******************************************************************-->
          <div class="criteria">
            <!-- ******************************************************************
                   *  一覧検索                                                      *
            ******************************************************************-->
            <div class="frm-row">
              <div class="frm-item">
                <div
                  class="frm-search frm-size-xl"
                  :class="[isSearched ? showSearched : showUnsearched]"
                >
                  <span class="frm-label">
                    &nbsp;
                    <img src="@/assets/images/TDSDC/icon_search.png" />
                  </span>
                  <input
                    type="search"
                    class="frm-search-text"
                    placeholder="検索キーワード"
                    maxlength="255"
                    v-model.trim="searchKey"
                  />
                  <!--                   <button
                    type="button"
                    class="frm-search-btn"
                    @click="searchNext"
                  ></button> -->
                </div>
              </div>
              <div class="frm-item">
                <span class="frm-label">決算日</span>
                <select
                  class="frm-select frm-size-s"
                  :class="[isMonthSelected ? showSelected : showUnselected]"
                  v-model="monthSelected"
                  v-show="!isMonthDisable"
                  @change="handleMonthChange"
                >
                  <option
                    v-for="item in monthList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>

                <select
                  class="frm-select frm-size-s setvalue"
                  :disabled="true"
                  v-show="isMonthDisable"
                >
                  <option>詳細指定中</option>
                </select>
              </div>

              <div class="frm-item">
                <span class="frm-label">主担当者</span>
                <select
                  class="frm-select frm-size-m"
                  :class="[
                    isMainPersonSelected ? showSelected : showUnselected,
                  ]"
                  v-model="mainPersonSelected"
                  v-show="!isMainPersonDisable"
                  @change="handleMainPersonChanged"
                >
                  <option
                    v-for="item in getPersonInChargeSelectList"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.userName }}
                  </option>
                </select>
                <select
                  class="frm-select frm-size-m setvalue"
                  :disabled="true"
                  v-show="isMainPersonDisable"
                >
                  <option>詳細指定中</option>
                </select>
              </div>
              <!--絞込条件設定-->
              <div class="frm-item">
                <button
                  class="frm-btn"
                  :class="[isFilterUsed ? showUsed : showUnused]"
                  @click="handleShowFilter"
                ></button>
              </div>
              <!--すべてクリアボタン-->
              <div class="frm-item" style="margin-left: 10px">
                <button
                  class="frm-btn-control ico ico-filter-close"
                  :disabled="isResetDisabled"
                  @click="handleReset"
                ></button>
              </div>
            </div>
          </div>
          <!-- ******************************************************************
                 *  事業者情報一覧                                                *
          ******************************************************************-->
          <div v-show="showCount" class="frm-item alignright">
            <p v-show="showSelectCount">{{ selectCount.toLocaleString() }}/{{ totalCount.toLocaleString() }}件</p>
            <p v-show="!showSelectCount">{{ totalCount.toLocaleString() }}件</p>
          </div>
          <div class="table-wrap" style="margin-top: 0px">
            <table class="table-select single-select">
              <colgroup>
                <!--事業者コード-->
                <col style="width: 130px" />
                <!--事業者名-->
                <col style="width: auto" />
                <!--法人個人区分-->
                <col style="width: 70px" />
                <!--決算日-->
                <col style="width: 80px" />
                <!--主担当者-->
                <col style="width: 130px" />
                <!--事業者アカウント-->
                <col style="width: 120px" />
                <!--事業者に対する機能利用権限の設定-->
                <col v-show="isFileManageShow" style="width: 160px" />
                <!--社員情報-->
                <col v-show="isEmployeeInfoShow" style="width: 130px" />
                <!-- No5事業者機能利用権限(電帳法)の追加対応 start-->
                <col v-show="isFunctionAuthoritySettingShow" style="width: 120px" />
                <!-- No5事業者機能利用権限(電帳法)の追加対応 end-->
                <!--保存日時-->
                <col style="width: 95px" />
                <!--ボタン群-->
                <col style="width: 150px" />
              </colgroup>
              <thead>
                <tr>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('businessOperatorCode')"
                  >
                    事業者<br />コード
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'businessOperatorCode' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'businessOperatorCode' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('businessOperatorName')"
                  >
                    事業者名
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'businessOperatorName' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'businessOperatorName' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover"
                    @click="sortData('businessOperatorType')"
                  >
                    法人<br />個人<br />区分
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'businessOperatorType' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'businessOperatorType' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover"
                    @click="sortData('accountClosingDate')"
                  >
                    決算日
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'accountClosingDate' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'accountClosingDate' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('personInChargeUserName')"
                  >
                    主担当者
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'personInChargeUserName' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'personInChargeUserName' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th class="sort hover" @click="sortData('bopUserCount')">
                    事業者
                    <br />アカウント
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'bopUserCount' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'bopUserCount' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    v-show="isEmployeeInfoShow"
                    class="sort hover"
                    @click="sortData('bopEmpCount')"
                  >
                    社員情報
                    <button
                      class="frm-btn-operation frm-btn-center"
                      type="button"
                      @click.stop="isEmployeeUsageStatusModalShowCheck()"
                    >
                      社員使用<br />状況の確認
                    </button>
                    <div class="sort-toggle">
                      <button class="sort-toggle-asc" :class="sort.key == 'bopEmpCount' && sort.isAsc ? 'on' : ''
                        " type="button">
                        asc
                      </button>
                      <button class="sort-toggle-desc" :class="sort.key == 'bopEmpCount' && !sort.isAsc ? 'on' : ''
                        " type="button">
                        desc
                      </button>
                    </div>
                  </th>
                  <!-- No5事業者機能利用権限(電帳法)の追加対応 start-->
                  <th v-show="isFileManageShow" class="sort hover" @click="sortData('functionAuthorityCondition')">
                    事業者機能利用<br />権限(電帳法)
                    <div class="sort-toggle">
                      <button class="sort-toggle-asc" :class="sort.key == 'functionAuthorityCondition' && sort.isAsc ? 'on' : ''
                        " type="button">
                        asc
                      </button>
                      <button class="sort-toggle-desc" :class="sort.key == 'functionAuthorityCondition' && !sort.isAsc ? 'on' : ''
                        " type="button">
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    v-show="isFunctionAuthoritySettingShow"
                    class="sort hover"
                    @click="sortData('functionAuthorityCondition')"
                  >
                    事業者に<br />対する<br />機能利用権限
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'functionAuthorityCondition' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'functionAuthorityCondition' &&
                          !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th class="sort hover" @click="sortData('dataUpdateDate')">
                    保存日時
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'dataUpdateDate' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'dataUpdateDate' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="info in filteredBusinessOperatorInfo"
                  :key="info.businessOperatorId"
                >
                  <td class="alignleft">
                    <span
                      class="frm-label"
                      v-show="
                        info.usageUser != null ||
                        info.signinBopUserList.length != 0 ||
                        dataLockInfoList.some(
                          (lockInfo) =>
                            lockInfo.businessOperatorID == info.businessOperatorId
                        )
                      "
                      v-tooltip="{
                        title: formatMessage(info),
                        position: 'top',
                      }"
                    >
                      <img src="@/assets/images/TDSDC/icon_editing.png" />
                    </span>
                    <span>{{ info.businessOperatorCode }}</span>
                  </td>
                  <td class="alignleft">
                    <span>{{ info.businessOperatorName }}</span>
                  </td>
                  <td class="aligncenter">
                    <span>
                      {{
                        corporationIndividualFormat(info.businessOperatorType)
                      }}
                    </span>
                  </td>
                  <td class="aligncenter">
                    <span>
                      {{
                        info.accountClosingMonth +
                        "月" +
                        info.accountClosingDay +
                        "日"
                      }}
                    </span>
                  </td>
                  <td class="alignleft">
                    <span>{{
                      info.personInChargeUserName
                        ? info.personInChargeUserName
                        : "-"
                    }}</span>
                  </td>
                  <td class="aligncenter">
                    <span>
                      {{ info.bopUserCount ? info.bopUserCount.toLocaleString() : 0 }}件
                    </span>
                    <button
                      class="frm-btn-operation"
                      type="button"
                      @click="handleAccountManagement(info)"
                    >
                      アカウント一覧
                    </button>
                  </td>
                  <td v-show="isEmployeeInfoShow" class="aligncenter">
                    <span>
                      {{ info.bopEmpCount ? info.bopEmpCount.toLocaleString() : 0 }}件
                    </span>
                    <button
                      class="frm-btn-operation frm-btn-center"
                      type="button"
                      @click="handleEmployeeInfo(info)"
                    >
                      社員情報一覧
                    </button>
                  </td>
                  <!-- No5事業者機能利用権限(電帳法)の追加対応 start-->
                  <td v-show="isFileManageShow" class="aligncenter">
                    <span>
                      {{ functionUsageAuthorityForBopFormat(info.functionAuthorityCondition) }}
                    </span>
                    <div style="display:flex;justify-content: center;">
                      <button class="frm-btn-operation" type="button" @click="handleSettingButtonClick(info)">
                        <span class="aligncnter">権限の設定</span>
                      </button>
                      <!--
                      <button :disabled="!info.functionAuthorityCondition" class="frm-btn-operation"
                        @click="SentMail(info)" type="button">
                        <span class="aligncenter">URL通知</span>
                      </button>
                      -->
                    </div>
                  </td>
                  <!-- No5事業者機能利用権限(電帳法)の追加対応 end-->
                  <td v-show="isFunctionAuthoritySettingShow" class="aligncenter">
                    <span>
                      {{
                        formatFunctionAuthoritySetting(
                          info.functionAuthorityCondition
                        )
                      }}
                    </span>
                    <button
                      class="frm-btn-operation frm-btn-center"
                      type="button"
                      @click="handleFunctionAuthoritySetting(info)"
                    >
                      権限の設定
                    </button>
                  </td>
                  <td class="aligncenter">
                    <span>
                      {{ formatDateTime_Date(info.dataUpdateDate) }}
                    </span>
                    <br />
                    <span>
                      {{ formatDateTime_Time(info.dataUpdateDate) }}
                    </span>
                  </td>
                  <td class="aligncenter">
                    <div class="frm-row separate">
                      <div class="frm-item">
                        <button
                          class="frm-btn-operation ico ico-edit"
                          type="button"
                          @click="handleEdit(info)"
                        >
                          編集
                        </button>
                      </div>
                      <div class="frm-item">
                        <button
                          class="frm-btn-operation ico ico-delete"
                          type="button"
                          @click="handleDelete(info)"
                          :disabled="isDisabled"
                        >
                          削除
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="table-select single-select" v-show="noDataPrompt">
              <tbody>
                <tr>
                  <p class="noData-area">
                    {{ noDataMsg }}
                  </p>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <STDSDC01C04ProcessingCompleteModal></STDSDC01C04ProcessingCompleteModal>
    <STDSDC01C05FileImportModal
      :pageId="pageId"
      @confirm="confirm"
    ></STDSDC01C05FileImportModal>
    <STDSDC01C06FileExportModal :pageId="pageId"></STDSDC01C06FileExportModal>
    <STDSDC01C07ProcessingConfirmModal
      :isConfirmShow="isConfirmShow"
      :isFileSelectedShow="isFileSelectedShow"
      :textArea="textArea"
      :deleteCheck="deleteCheck"
      @agree="agree($event)"
      @disagree="disagree"
    ></STDSDC01C07ProcessingConfirmModal>
    <STDSDC01C09FilterCompleteModal
      ref="STDSDC01C09FilterCompleteModal"
      :isShow="isFilterShow"
      :pageId="pageId"
      :loginSystem="loginSystem"
      :yearendTaxAdjustment="yearendTaxAdjustment"
      :keyWordFilterInit="searchKey"
      :bopDataFilterInit="bopDataFilterInit"
      :STDSDC02C01FilterInit="STDSDC02C01FilterInit"
      @searchBtn="SearchBtn"
      @cancelBtn="CancelBtn"
    ></STDSDC01C09FilterCompleteModal>
    <STDSDC01C10EmployeeUsageStatusModal
      :isShow="this.isEmployeeUsageStatusModalShow"
      :usageStatusUsed="this.usageStatusUsed"
      :usageStatusTotal="this.usageStatusTotal"
      @cancel="cancelSTDSDC01C10"
    ></STDSDC01C10EmployeeUsageStatusModal>
    
    
    
    <!-- No5事業者機能利用権限(電帳法)の追加対応 start-->
    <STFMFM02C30SentMailtNotificationContentModal :isProcessShow="STFMFM02C30Modle.isProcessShow"
      :businessOperatorId="STFMFM02C30Modle.businessOperatorId"
      :accountingOfficeName="STFMFM02C30Modle.accountingOfficeName"
      :businessOperatorName="STFMFM02C30Modle.businessOperatorName" 
      :mailAddress="STFMFM02C30Modle.mailAddress"
      @cancelSend="cancelSend"></STFMFM02C30SentMailtNotificationContentModal>
    <!-- No5事業者機能利用権限(電帳法)の追加対応 end-->
    <STDSDC01C19ImportFromTDKModal
      :isImportFromTDKShow="this.isImportFromTDKModalShow"
      :pageId="pageId"
      @reload="reloadSTDSDC02C17"
      @cancel="cancelSTDSDC02C17"
    ></STDSDC01C19ImportFromTDKModal>
  </div>
</template>

<script>
import moment from "moment";
import { mapMutations } from "vuex";
import _ from "lodash";
import ErrorMessage from "@/components/ErrorMessage.vue";
import HeaderNav from "@/components/AccountingHeader.vue";
import STDSDC01C04ProcessingCompleteModal from "@/components/STDSDC01C04ProcessingCompleteModal.vue";
import STDSDC01C05FileImportModal from "@/components/STDSDC01C05FileImportModal.vue";
import STDSDC01C06FileExportModal from "@/components/STDSDC01C06FileExportModal.vue";
import STDSDC01C07ProcessingConfirmModal from "@/components/STDSDC01C07ProcessingConfirmModal.vue";
import STDSDC01C09FilterCompleteModal from "@/components/STDSDC01C09FilterCompleteModal.vue";
import STDSDC01C10EmployeeUsageStatusModal from "@/components/STDSDC01C10EmployeeUsageStatusModal.vue";
import STFMFM02C30SentMailtNotificationContentModal from "@/components/STFMFM02C30SentMailtNotificationContentModal.vue";
import STDSDC01C19ImportFromTDKModal from "@/components/STDSDC01C19ImportFromTDKModal.vue";

import Common from "@/util/common.js";
import Validation from "@/util/validation.js";
import {
  API_Initialize,
  API_DeleteBopInfo,
} from "@/api/Modules/DC02/STDSDC02C01.js";

import {
  API_SetFilter,
  API_BopDataLock,
} from "@/api/Modules/CM04/STDSCM04C00.js";
// No5事業者機能利用権限(電帳法) start
import {
  API_STFMFM02C01_GetMailAddress,
} from "@/api/Modules/FM02/STFMFM02C01.js";
// No5事業者機能利用権限(電帳法) end
import {
  CORPORATION_DIVISION_LIST,
  MONTH_LIST,
  WITH_WITHOUT_LIST,
  WITH_WITHOUT_EMAIL_LIST,
  DETAIL_DURING_DATE_LIST,
  DETAIL_BLANK_NONPERMISSION_LIST,
  DETAIL_BUSINESS_CODE_LIST,
  FUNCTION_USAGE_AUTHORITY_FOR_BOP_LIST
} from "@/util/data.js";
import {
  NOTIFICATION_STATUS,
  CORPORATION_INDIVIDUAL_DIVISION,
} from "@/util/enum.js";

export default {
  name: "STDSDC02C01",
  components: {
    HeaderNav,
    ErrorMessage,
    STDSDC01C04ProcessingCompleteModal,
    STDSDC01C05FileImportModal,
    STDSDC01C06FileExportModal,
    STDSDC01C07ProcessingConfirmModal,
    STDSDC01C09FilterCompleteModal,
    STDSDC01C10EmployeeUsageStatusModal,
    STFMFM02C30SentMailtNotificationContentModal, // No5事業者機能利用権限(電帳法)
    STDSDC01C19ImportFromTDKModal
  },
  data() {
    return {
      isMonthDisable: false,
      isMainPersonDisable: false,
      isDisabled: false,
      isShowProcessingConfirmModal: false,
      expandFlag: true,
      designateFlag: true,
      corporationDivisionSelected: 0,
      monthSelected: 0,
      mainPersonSelected: 0,
      accountSelected: 0,
      functionAuthorityConditionSelected: 0,
      bopCodeSelected: 0,
      bopCode: "",
      bopNameSelected: 0,
      bopName: "",
      detailDuringDateSelected: 0,
      monthStart: "",
      dayStart: "",
      monthEnd: "",
      dayEnd: "",
      isAfterAdd: false,
      addBusinessOperatorCode: "",
      searchKey: "",
      highlights: [],
      highlightIndex: -1,
      sort: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      totalCount: 0,
      selectCount: 0,
      showSelectCount: false,
      showCount: true,
      allData: [],
      businessOperatorInfo: [],
      deleteRow: {},
      changeData: {},
      errors: [],
      corporationDivisionList: CORPORATION_DIVISION_LIST,
      monthList: MONTH_LIST,
      withWithoutList: WITH_WITHOUT_LIST,
      withWithoutEmailList: WITH_WITHOUT_EMAIL_LIST,
      detailDuringDateList: DETAIL_DURING_DATE_LIST,
      detailBlankNonpermissionList: DETAIL_BLANK_NONPERMISSION_LIST,
      // true:処理確認画面表示 / false:処理画面非表示
      isConfirmShow: false,
      // 入力:入力内容を表示 / 未入力:エリア非表示
      textArea: Common.getMessage("MTCL2029", ["", ""]),
      // 入力:入力リストを☑チェックボックスで表示 / 未入力:エリア非表示(赤字)
      deleteCheck: Common.getMessage("MTCL2048", [
        "事業者に紐づく情報（データ収集・配信サービスおよびすべてのオプションサービスの情報）",
      ]),
      businessOperatorCode: undefined,
      pageId: "STDSDC02C01",
      isSearchKeyEnter: false,
      noDataPrompt: false,
      noDataMsg: Common.getMessage("MTCL1118", ["事業者情報"]),
      startFlg: false,
      mainPersonSelect: [],
      showUsed: "frm-btn-control setvalue ico ico-filter",
      showUnused: "frm-btn-control ico ico-filter",
      loginSystem: "",
      yearendTaxAdjustment: false,
      isFilterShow: false,
      showSearched: "frm-search frm-size-xl setvalue",
      showUnsearched: "frm-search frm-size-xl",
      showSelected: "frm-select frm-size-s setvalue ",
      showUnselected: "frm-select frm-size-s ",
      copyBopDataFilter: {},
      bopDataFilterInit: {},
      STDSDC02C01FilterInit: {},
      isFilterUsed: false,
      personInChargeOption: 0,
      personInChargeInput: "",
      titletip: "利用者：",
      titleBopUsertip: "(事業者)",
      signinBopUserNameList: "",
      isBopInfoAvailable: true,
      isFileSelectedShow: false,
      usageStatusUsed: 0, // データ使用状況現在
      usageStatusTotal: 0, // データ使用状況最大
      isFunctionSettingAvailable: false, //権限設定が有効か(許可/拒否)
      isEmployeeUsageStatusModalShow: false, //社員使用状況確認子画面制御
      // No5事業者機能利用権限(電帳法)の追加対応 --start
      functionUsageAuthorityForBopList: FUNCTION_USAGE_AUTHORITY_FOR_BOP_LIST,
      businessOperatorId: 0,
      businessOperatorName: "",
      mailAddress: "",　
      accountingOfficeName: "",
      STFMFM02C30Modle: {
        isProcessShow: false,
        businessOperatorId: 0,
        accountingOfficeName: "",
        businessOperatorName: "",
        mailAddress: "",
      },
      // No5事業者機能利用権限(電帳法)の追加対応 --end
      isImportFromTDKModalShow: false,
      dataLockInfoList: [], //データロック情報リスト
    };
  },
  mounted() {
    this.initFocus();
    this.importDialogue(false);
    this.exportDialogue(false);
    this.processDialogue(true);
    //検索キーワード適用
    this.isSearchKeyEnter = true;
    // 事業者ヘッダー情報リストを取得する
    API_Initialize()
      .then((response) => {
        if (response.errorCD) {
          if (response.errorCD == "MTCL1036") {
            this.totalCount = 0;
            this.showCount = true;
            this.noDataPrompt = true;
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        } else {
          this.loginSystem = response.loginSystem;
          this.startFlg = true;
          //各事業者の詳細データ
          let bopDataHeaders = response.tzafdcBopDataHeaders;
          //各事業者の機能利用権限リスト
          let authorityInfoEntityList = response.authorityInfoEntityList;
          // No5事業者機能利用権限(電帳法) 
          this.accountingOfficeName = response.customerName
          // 事業者ソートのためにフリガナがない場合は事業者名を代入しておく
          bopDataHeaders.forEach((item) => {
            if (item.businessOperatorNameF == "") {
              item.businessOperatorNameF = item.businessOperatorName;
            }

            item.personInChargeUserName = item.personInCharge?.userName
              ? item.personInCharge?.userName
              : "";
            //権限の初期値設定
            item.functionAuthorityCondition = false;
            //各事業者の機能利用権限をリストへ追加
            var checkIndex = authorityInfoEntityList?.findIndex(
              (e) => e.id == item.businessOperatorId
            );
            if (checkIndex >= 0) {
              item.functionAuthorityCondition =
                authorityInfoEntityList[checkIndex].permission;
            }
          });

          this.businessOperatorInfo = bopDataHeaders;
          this.allData = bopDataHeaders;
          this.dataLockInfoList = response.dataLockInfoList
            ? response.dataLockInfoList
            : [];

          // 保存されているフィルタ条件の適用
          if (
            response.stdsdC02C01Filter.result != "0001" &&
            response.stdsdC02C01Filter
          ) {
            this.STDSDC02C01FilterInit = response.stdsdC02C01Filter;
            this.monthSelected = response.stdsdC02C01Filter.accountClosingMonth;
            this.mainPersonSelected = response.stdsdC02C01Filter.personInCharge;
            if (this.monthSelected == 99) {
              this.isMonthDisable = true;
            } else {
              this.isMonthDisable = false;
            }
            if (this.mainPersonSelected == 99) {
              this.isMainPersonDisable = true;
            } else {
              this.isMainPersonDisable = false;
            }
          }
          if (
            response.bopDataFilter.result != "0001" &&
            response.bopDataFilter
          ) {
            this.bopDataFilterInit = response.bopDataFilter;
            this.bopCodeSelected =
              response.bopDataFilter.businessOperatorCodeOption;
            this.bopCode = response.bopDataFilter.businessOperatorCode;
            this.bopNameSelected =
              response.bopDataFilter.businessOperatorNameOption;
            this.bopName = response.bopDataFilter.businessOperatorName;
            this.corporationDivisionSelected =
              response.bopDataFilter.businessOperatorType;
            this.accountSelected = response.bopDataFilter.bopAccountCondition;
            this.functionAuthorityConditionSelected =
              response.bopDataFilter.functionAuthorityCondition;
            this.detailDuringDateSelected =
              response.bopDataFilter.accountClosingOption;
            this.monthStart = response.bopDataFilter.accountClosingFromMonth;
            this.dayStart = response.bopDataFilter.accountClosingFromDay;
            this.monthEnd = response.bopDataFilter.accountClosingToMonth;
            this.dayEnd = response.bopDataFilter.accountClosingToDay;
            this.searchKey = response.keywordFilter.searchKey;
            this.isFilterUsed = response.bopDataFilter.motoPageHandleShowBtn;
            this.personInChargeOption =
              response.bopDataFilter.personInChargeOption;
            this.personInChargeInput = response.bopDataFilter.personInCharge;
            this.handleSetting();
          }
          if (
            response.keywordFilter.result != "0001" &&
            response.keywordFilter
          ) {
            this.searchKey = response.keywordFilter.searchKey;
          }

          this.addBusinessOperatorCode = history.state.businessOperatorCode;
          // 編集・登録画面から正常終了で遷移された場合、登録データを最終行に移動 ※未ソート
          if (history.state.businessOperatorCode) {
            var changeDataIndex = this.businessOperatorInfo.findIndex(
              (e) => e.businessOperatorCode == this.addBusinessOperatorCode
            );
            if (changeDataIndex == -1) {
              var changeDataIndexInAllData = this.allData.findIndex(
                (e) => e.businessOperatorCode == this.addBusinessOperatorCode
              );
              this.changeData = this.allData[changeDataIndexInAllData];
              this.businessOperatorInfo.push(this.changeData);
            }
            this.changeIsAfterAdd(true);
          }

          //フィルター利用確認
          this.checkFilterUsed();

          //機能利用権限確認
          this.isBopInfoAvailable = response.isBopInfoAvailableService;

          //「年末調整」オプション
          this.yearendTaxAdjustment = response.yearendTaxAdjustment;

          // 社員数上限値
          this.usageStatusTotal = response.totalBopEmployeeDataCount;
          //社員数使用済合計
          this.usageStatusUsed = response.usedBopEmployeeDataCount;
        }
      })
      .finally(() => {
        this.processDialogue(false);
      });
  },
  watch: {
    searchKey: {
      handler: "filterContext",
      immediate: true,
    },
  },
  computed: {
    //リセット制御
    isResetDisabled() {
      if (
        !this.searchKey &&
        this.mainPersonSelected == 0 &&
        this.monthSelected == 0 &&
        !this.isFilterUsed
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 主担当者をフィルタ状態にする
    isMainPersonSelected() {
      return this.mainPersonSelected != 0 ? true : false;
    },
    // 決算日をフィルタ状態にする
    isMonthSelected() {
      return this.monthSelected != 0 ? true : false;
    },
    // 検索キーワードをフィルタ状態にする
    isSearched() {
      return this.searchKey != "" ? true : false;
    },
    // 詳細_事業者コードテキストコントロールを非活性にする
    isBopCodeDisabled() {
      return this.bopCodeSelected == 0 ? true : false;
    },
    // 詳細_事業者名テキストコントロールを非活性にする
    isBopNameDisabled() {
      return this.bopNameSelected == 0 ? true : false;
    },
    // ソート、通常フィルタ
    filteredBusinessOperatorInfo() {
      var filterInfo = this.businessOperatorInfo;
      const searchCorporationDivision = this.corporationDivisionSelected;
      const searchFunctionAuthorityCondition =
        this.functionAuthorityConditionSelected;
      const searchMonth = this.monthSelected;
      const personInCharge = this.mainPersonSelected;

      // 法人個人区分
      if (searchCorporationDivision != 0) {
        filterInfo = filterInfo.filter((item) => {
          return item.businessOperatorType == searchCorporationDivision;
        });
      }
      //権限設定
      if (searchFunctionAuthorityCondition != 0) {
        filterInfo = filterInfo.filter((item) => {
          return searchFunctionAuthorityCondition == 1
            ? item.functionAuthorityCondition == true
            : item.functionAuthorityCondition == false;
        });
      }

      // 決算日
      if (searchMonth != 0 && searchMonth != 99) {
        filterInfo = filterInfo.filter((item) => {
          return item.accountClosingMonth == searchMonth;
        });
      }

      // 主担当者
      if (
        personInCharge != 0 &&
        personInCharge != DETAIL_BUSINESS_CODE_LIST[3].code &&
        personInCharge != 99
      ) {
        filterInfo = filterInfo.filter((item) => {
          return item.personInChargeUserName == personInCharge;
        });
      } else if (personInCharge == DETAIL_BUSINESS_CODE_LIST[3].code) {
        filterInfo = filterInfo.filter((item) => {
          return item.personInChargeUserName == "";
        });
      }

      //事業者への機能開放 TODO

      //検索キーワード
      if (this.searchKey) {
        filterInfo = filterInfo.filter((item) => {
          return (
            item.personInChargeUserName?.includes(this.searchKey) ||
            item.businessOperatorCode.includes(this.searchKey) ||
            item.businessOperatorName.includes(this.searchKey) ||
            this.corporationIndividualFormat(
              item.businessOperatorType
            ).includes(this.searchKey) ||
            (
              item.accountClosingMonth +
              "月" +
              item.accountClosingDay +
              "日"
            ).includes(this.searchKey) ||
            (item.bopEmpCount + "件").includes(this.searchKey) ||
            (item.bopUserCount + "件").includes(this.searchKey) ||
            this.formatFunctionAuthoritySetting(
              item.functionAuthorityCondition
            ).includes(this.searchKey) ||
            this.formatDateTime_Date(item.dataUpdateDate).includes(
              this.searchKey
            ) ||
            this.formatDateTime_Time(item.dataUpdateDate).includes(
              this.searchKey
            )
          );
        });
      }

      filterInfo = Common.listSort(this.sort.key, this.sort.isAsc, filterInfo);

      // 登録・変更データがリストにない場合は最終行に追加
      if (this.addBusinessOperatorCode && this.isAfterAdd) {
        var changeDataIndex = filterInfo.findIndex(
          (e) => e.businessOperatorCode == this.addBusinessOperatorCode
        );
        if (changeDataIndex == -1) {
          var changeDataIndexInAllData = this.allData.findIndex(
            (e) => e.businessOperatorCode == this.addBusinessOperatorCode
          );
          this.setChangeDate(this.allData[changeDataIndexInAllData]);
          filterInfo.push(this.changeData);
        }
        this.changeIsAfterAdd(false);
      }

      return filterInfo;
    },
    // 主担当者プルダウンドロップリスト
    getPersonInChargeSelectList() {
      const set = new Set(
        this.allData
          .map((item) => item.personInChargeUserName)
          .filter((item) => item != "")
          .sort()
      );
      let personInChargeList = [];
      for (let item of set) {
        personInChargeList.push({ userName: item, value: item });
      }
      personInChargeList.unshift({ userName: "指定しない", value: 0 });
      //未設定
      personInChargeList.push({
        userName: DETAIL_BUSINESS_CODE_LIST[3].name,
        value: DETAIL_BUSINESS_CODE_LIST[3].code,
      });
      return personInChargeList;
    },
    //列表示の制御
    //社員情報列
    isEmployeeInfoShow() {
      if (this.loginSystem == "DataCollection" && this.yearendTaxAdjustment) {
        return true;
      } else if (
        this.loginSystem == "DataCollection" &&
        !this.yearendTaxAdjustment
      ) {
        return false;
      } else {
        return false;
      }
    },
    // No5事業者機能利用権限(電帳法)の追加対応 start
    isFileManageShow() {
      // FileManage
      if (this.loginSystem == "FileManage") {
        return true;
      } else {
        return false;
      }
    },
    // No5事業者機能利用権限(電帳法)の追加対応 end
    

    //列表示の制御
    //事業者に対する機能利用権限
    isFunctionAuthoritySettingShow() {
      if (
        (this.loginSystem == "DataCollection" && this.yearendTaxAdjustment) ||
        this.loginSystem == "FileSystem"
      ) {
        return true;
      } else if (
        this.loginSystem == "DataCollection" &&
        !this.yearendTaxAdjustment
      ) {
        return false;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapMutations("businessModule", [
      "importDialogue",
      "exportDialogue",
      "processDialogue",
    ]),

    // **********************************************
    // インポート完了画面更新
    // **********************************************
    confirm(flg) {
      if (flg == true) location.reload();
    },
    // **********************************************
    // 処理確認画面ダイアログではいが選択された時の処理
    // **********************************************
    agree(val) {
      // エラーの初期化
      this.errors = [];

      // 処理確認ダイアログを閉じる
      this.isConfirmShow = false;

      // パラメータ設定
      const param = {
        businessOperatorId: this.deleteRow.businessOperatorId,
      };

      // 削除ボタン 非活性化
      this.isDisabled = true;
      // 削除処理
      API_DeleteBopInfo(param).then((response) => {
        if (response.errorCD) {
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        } else {
          var index = this.businessOperatorInfo.findIndex(
            (e) => e.businessOperatorId === this.deleteRow.businessOperatorId
          );
          this.businessOperatorInfo.splice(index, 1);
          this.allData = [...this.businessOperatorInfo];
        }
        // 削除ボタン 活性化
        this.isDisabled = false;
        this.checkFilterUsed();
      });
    },
    // **********************************************
    // 処理確認画面ダイアログでキャンセルが選択された時の処理
    // **********************************************
    disagree() {
      this.isConfirmShow = false;
    },
    // **********************************************
    // 検索アイコンをクリック時、該当する部分の色を変える
    // **********************************************
    searchNext() {
      if (this.highlights.length > 0) {
        let targetIndex = this.highlightIndex;
        const maxIndex = this.highlights.length - 1;

        targetIndex++;

        if (targetIndex > maxIndex) {
          targetIndex = 0;
        }

        this.highlightIndex = targetIndex;

        for (let i = 0; i < this.highlights.length; i++) {
          const target = this.highlights[i];

          target.classList.remove("currentHighlight");

          if (i === targetIndex) {
            target.classList.add("currentHighlight");
            const offsetTop = target.offsetTop - 10;
            const scrollTop = Math.max(0, offsetTop); // 数値がマイナスの場合はゼロにする
            window.scrollTo(0, scrollTop);
          }
        }
      }
    },
    // // **********************************************
    // // ハイライト表示
    // // **********************************************
    // highlight(val) {
    //   const reg = new RegExp(this.searchKey, "gi");
    //   return val.replace(
    //     reg,
    //     (match) => `<span class='highlight'>${match}</span>`
    //   );
    // },
    // **********************************************
    // キーワードが変更になったら全てのハイライト部分を取得するようにする
    // **********************************************
    filterContext(keyword) {
      if (this.startFlg) {
        this.checkFilterUsed();
      }
      //this.highlightIndex = -1;
      //this.highlights = document.getElementsByClassName("highlight");
      if (this.isSearchKeyEnter) {
        // フィルター条件の保存
        this.saveFilter();
      }
    },

    // **********************************************
    // ソート実施
    // **********************************************
    sortData(key) {
      Common.sortData(key, this);
    },

    handleImportDialog() {
      //機能利用権限チェック
      this.errors = [];
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }

      if (!this.errors || this.errors.length == 0) {
        this.importDialogue(true);
      }
    },
    handleExportDialog() {
      this.exportDialogue(true);
    },
    // 通知ステータスのフォーマット
    notificationStatusFormat(data) {
      // 未通知
      if (data == NOTIFICATION_STATUS.noNotification.code) {
        return NOTIFICATION_STATUS.noNotification.text;

        // 通知済
      } else if (data == NOTIFICATION_STATUS.notified.code) {
        return NOTIFICATION_STATUS.notified.text;
      }
    },
    // 法人個人区分のフォーマット
    corporationIndividualFormat(data) {
      // 法人
      if (data == CORPORATION_INDIVIDUAL_DIVISION.LegalEntity.code) {
        return CORPORATION_INDIVIDUAL_DIVISION.LegalEntity.text;

        // 個人
      } else if (data == CORPORATION_INDIVIDUAL_DIVISION.Individual.code) {
        return CORPORATION_INDIVIDUAL_DIVISION.Individual.text;
      }
    },
    // 事業者アカウントの表示フォーマット
    withWithoutFormat(data) {
      // 有り
      if (data) {
        return this.withWithoutList[1].name;
      }
      // 無し
      else {
        return this.withWithoutList[2].name;
      }
    },
    // No5事業者機能利用権限(電帳法)の追加対応 - 事業者に対する機能利用権限の表示フォーマット
    functionUsageAuthorityForBopFormat(data) {
      // 有り
      if (data) {
        return this.functionUsageAuthorityForBopList[0].name;
      }
      // 無し
      else {
        return this.functionUsageAuthorityForBopList[1].name;
      }
    },

    // 事業者からの通知先の表示フォーマット
    withWithoutAddressFormat(data) {
      // 有り
      if (data) {
        return this.withWithoutEmailList[1].name;
      }
      // 無し
      else {
        return this.withWithoutEmailList[2].name;
      }
    },
    // **********************************************
    // 日付のフォーマット(YYYY/MM/DD)
    // **********************************************
    formatDateTime_Date(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD");
      }
    },
    // **********************************************
    // 日付のフォーマット(HH:mm:ss)
    // **********************************************
    formatDateTime_Time(value) {
      if (value) {
        return moment(String(value)).format("HH:mm:ss");
      }
    },
    formatFunctionAuthoritySetting(value) {
      return value ? "許可" : "拒否";
    },
    // 詳細_決算日入力値チェック
    dateValidate() {
      // 「指定しない」はチェックしない
      if (
        this.detailDuringDateSelected != 0 &&
        this.detailDuringDateSelected != 3
      ) {
        return Validation.checkFilterDateMD(
          this.detailDuringDateSelected,
          this.monthStart,
          this.dayStart,
          this.monthEnd,
          this.dayEnd,
          "決算日"
        );
      }

      return "";
    },
    // 通常フィルタ_決算日を取得
    handleMonthChange(e) {
      this.checkFilterUsed();
      this.monthSelected = e.target.value;
      this.saveFilter();
    },
    // 通常フィルタ_主担当者を取得
    handleMainPersonChanged(e) {
      this.mainPersonSelected = e.target.value;
      this.checkFilterUsed();
      this.saveFilter();
    },
    // フィルタ_DB保存
    saveFilter() {
      // パラメータ設定
      const normalFileter = {
        accountClosingMonth: this.monthSelected,
        personInCharge: this.mainPersonSelected,
      };

      const keyWordFilter = {
        searchKey: this.searchKey,
        pageID: this.pageId,
        sessinID: this.$cookies.get("SessionID"),
      };

      let params = {
        STDSDC02C01Filter: normalFileter,
        keyWordFilter: keyWordFilter,
      };

      // フィルター条件保存処理
      API_SetFilter(params);
    },
    // 設定ボタンをクリック
    handleSetting() {
      this.businessOperatorInfo = this.allData;
      this.errors = [];

      // 事業者コードが「指定しない」以外の場合フィルタする
      if (this.bopCodeSelected != 0) {
        // 「右記から始まる」の場合
        if (this.bopCodeSelected == 3) {
          this.businessOperatorInfo = this.businessOperatorInfo.filter(
            (element) => {
              return _.startsWith(element.businessOperatorCode, this.bopCode);
            }
          );
          // 「右記を含む」の場合
        } else if (this.bopCodeSelected == 1) {
          this.businessOperatorInfo = this.businessOperatorInfo.filter(
            (element) => {
              return _.includes(element.businessOperatorCode, this.bopCode);
            }
          );
          // 「右記を含まない」の場合
        } else if (this.bopCodeSelected == 2) {
          this.businessOperatorInfo = this.businessOperatorInfo.filter(
            (element) => {
              return !_.includes(element.businessOperatorCode, this.bopCode);
            }
          );
        }
      }
      // 事業者名が「指定しない」以外の場合フィルタする
      if (this.bopNameSelected != 0) {
        // 「右記から始まる」の場合
        if (this.bopNameSelected == 3) {
          this.businessOperatorInfo = this.businessOperatorInfo.filter(
            (element) => {
              return _.startsWith(element.businessOperatorName, this.bopName);
            }
          );
          // 「右記を含む」の場合
        } else if (this.bopNameSelected == 1) {
          this.businessOperatorInfo = this.businessOperatorInfo.filter(
            (element) => {
              return _.includes(element.businessOperatorName, this.bopName);
            }
          );
          // 「右記を含まない」の場合
        } else if (this.bopNameSelected == 2) {
          this.businessOperatorInfo = this.businessOperatorInfo.filter(
            (element) => {
              return !_.includes(element.businessOperatorName, this.bopName);
            }
          );
        }
      }

      // 決算日のフィルタ
      if (
        this.detailDuringDateSelected != 0 &&
        this.detailDuringDateSelected != 3
      ) {
        var inputStartDate =
          Number(this.monthStart) * 100 + Number(this.dayStart);
        // 指定期間
        if (this.detailDuringDateSelected == DETAIL_DURING_DATE_LIST[1].code) {
          this.designateFlag = false;
          var inputEndDate = Number(this.monthEnd) * 100 + Number(this.dayEnd);
          let msg = this.dateValidate();
          if (msg != "YearendStraddle") {
            this.businessOperatorInfo = this.businessOperatorInfo.filter(
              (element) => {
                var sourceDate =
                  element.accountClosingMonth * 100 + element.accountClosingDay;
                return (
                  inputStartDate <= sourceDate && sourceDate <= inputEndDate
                );
              }
            );
          } else {
            // 年末またぎの場合の検索
            var inputEndDateBefore = 12031;
            var inputStartDateAfter = 101;

            this.businessOperatorInfo = this.businessOperatorInfo.filter(
              (element) => {
                var sourceDate =
                  element.accountClosingMonth * 100 + element.accountClosingDay;
                return (
                  (inputStartDate <= sourceDate &&
                    sourceDate <= inputEndDateBefore) ||
                  (inputStartDateAfter <= sourceDate &&
                    sourceDate <= inputEndDate)
                );
              }
            );
          }
          // 指定日
        } else if (
          this.detailDuringDateSelected == DETAIL_DURING_DATE_LIST[2].code
        ) {
          this.designateFlag = true;
          this.businessOperatorInfo = this.businessOperatorInfo.filter(
            (element) => {
              const sourceDate =
                element.accountClosingMonth * 100 + element.accountClosingDay;
              return inputStartDate === sourceDate;
            }
          );
        }
      }

      // 主担当者が「指定しない」以外の場合　フィルタする
      if (this.personInChargeOption != 0) {
        // 「右記を含む」の場合
        if (this.personInChargeOption == 1) {
          this.businessOperatorInfo = this.businessOperatorInfo.filter(
            (element) => {
              return _.includes(
                element.personInChargeUserName,
                this.personInChargeInput
              );
            }
          );
          // 「右記を含まない」の場合
        } else if (this.personInChargeOption == 2) {
          this.businessOperatorInfo = this.businessOperatorInfo.filter(
            (element) => {
              return !_.includes(
                element.personInChargeUserName,
                this.personInChargeInput
              );
            }
          );
        }
      }

      //事業者アカウント
      // if (this.accountSelected != 0) {
      //   this.businessOperatorInfo = this.businessOperatorInfo.filter((item) => {
      //     return (
      //       this.withWithoutFormat(item.hasBopUser) ==
      //       this.withWithoutList[this.accountSelected].name
      //     );
      //   });
      // }

      // 事業者からの通知先
      // if (this.notificationDestinationSelected != 0) {
      //   this.businessOperatorInfo = this.businessOperatorInfo.filter((item) => {
      //     return (
      //       this.withWithoutAddressFormat(item.hasNotificationMailAddress) ==
      //       this.withWithoutEmailList[this.notificationDestinationSelected].name
      //     );
      //   });
      // }

      this.checkFilterUsed();
    },
    // すべての条件をクリア
    handleReset() {
      this.designateFlag = true;
      this.errors = [];
      this.corporationDivisionSelected = 0;
      this.monthSelected = 0;
      this.accountSelected = 0;
      this.functionAuthorityConditionSelected = 0;
      this.mainPersonSelected = 0;
      this.bopCodeSelected = 0;
      this.bopCode = "";
      this.bopNameSelected = 0;
      this.bopName = "";
      this.detailDuringDateSelected = 0;
      this.monthStart = "";
      this.dayStart = "";
      this.monthEnd = "";
      this.dayEnd = "";
      this.searchKey = "";
      this.businessOperatorInfo = this.allData;
      this.isMonthDisable = false;
      this.isMainPersonDisable = false;
      this.isFilterUsed = false;
      this.checkFilterUsed();
      this.sort = {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      };
      this.$refs.STDSDC01C09FilterCompleteModal.handleReset();

      // フィルター条件の保存
      this.saveFilter();
    },
    // 編集ボタンをクリック
    handleAccountManagement(selectedRow) {
      //機能利用権限チェック
      this.errors = [];
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }

      if (!this.errors || this.errors.length == 0) {
        // 事業者IDを渡して事業者情報編集画面に遷移する
        this.$cookies.set(
          "businessOperatorId",
          selectedRow.businessOperatorId,
          "0"
        );
        this.$cookies.set(
          "businessOperatorCode",
          selectedRow.businessOperatorCode,
          "0"
        );
        this.$cookies.set(
          "businessOperatorName",
          selectedRow.businessOperatorName,
          "0"
        );
        this.$redirect({ name: "STDSDC02C06" });
      }
    },
    // 社員情報一覧ボタンをクリック
    handleEmployeeInfo(selectedRow) {
      //機能利用権限チェック
      this.errors = [];
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }

      if (!this.errors || this.errors.length == 0) {
        // 事業者IDを渡して社員情報画面に遷移する
        this.$cookies.set(
          "businessOperatorId",
          selectedRow.businessOperatorId,
          "0"
        );
        this.$cookies.set(
          "businessOperatorCode",
          selectedRow.businessOperatorCode,
          "0"
        );
        this.$cookies.set(
          "businessOperatorName",
          selectedRow.businessOperatorName,
          "0"
        );
        this.$redirect({ name: "STDSDC02C10" });
      }
    },
    // 権限の設定ボタンをクリック
    handleFunctionAuthoritySetting(selectedRow) {
      //機能利用権限チェック
      this.errors = [];
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }
      if (!this.errors || this.errors.length == 0) {
        // 事業者ID
        this.$cookies.set(
          "businessOperatorId",
          selectedRow.businessOperatorId,
          "0"
        );
        // 事業者コード
        this.$cookies.set(
          "businessOperatorCode",
          selectedRow.businessOperatorCode,
          "0"
        );
        // 事業者名
        this.$cookies.set(
          "businessOperatorName",
          selectedRow.businessOperatorName,
          "0"
        );
        if (!this.errors || this.errors.length == 0) {
          this.processDialogue(true);
          API_BopDataLock({
            businessOperatorId: selectedRow.businessOperatorId,
          }).then((response) => {
            this.processDialogue(false);
            if (response.errorCD) {
              this.errors = [];
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            } else {
              // 事業者IDを渡して事業者情報編集画面に遷移する
              this.$router.push({
                name: "STDSDC02C15",
              });
              // 編集ボタン押下行の書類名
              this.$cookies.set(
                "DC02C15BusinessOperatorId",
                selectedRow.businessOperatorId,
                "0"
              );
            }
          });
        }
      }
    },
    // 新規事業者登録ボタンをクリック
    handleNewAdd() {
      //機能利用権限チェック
      this.errors = [];
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }

      if (!this.errors || this.errors.length == 0) {
        // 事業者情報新規登録画面に遷移する
        this.$router.push({
          name: "STDSDC02C02",
        });
      }
    },
    // 編集ボタンをクリック
    handleEdit(selectedRow) {
      //機能利用権限チェック
      this.errors = [];
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }
      // 相関チェック_ロックユーザー確認
      if (
        selectedRow.usageUser != null ||
        selectedRow.signinBopUserList.length !== 0
      ) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError(
              "MTCL1066",
              Common.getMessage("MTCL1066", [])
            )
          );
        }
      }

      if (!this.errors || this.errors.length == 0) {
        this.processDialogue(true);
        API_BopDataLock({
          businessOperatorId: selectedRow.businessOperatorId,
        }).then((response) => {
          this.processDialogue(false);
          if (response.errorCD) {
            this.errors = [];
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          } else {
            // 事業者IDを渡して事業者情報編集画面に遷移する
            this.$router.push({
              name: "STDSDC02C05",
            });
            // 編集ボタン押下行の書類名
            this.$cookies.set(
              "DC02C05BusinessOperatorId",
              selectedRow.businessOperatorId,
              "0"
            );
          }
        });
      }
    },
    // 削除ボタンをクリック
    handleDelete(selectedRow) {
      //機能利用権限チェック
      this.errors = [];
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }

      if (!this.errors || this.errors.length == 0) {
        this.textArea = Common.getMessage("MTCL2029", [
          selectedRow.businessOperatorCode +
            "_" +
            selectedRow.businessOperatorName,
          "",
        ]);
        this.deleteRow = selectedRow;
        this.isConfirmShow = true;
      }
    },
    // IsAfterAdd変更
    changeIsAfterAdd(flag) {
      this.isAfterAdd = flag;
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.newAddButton.focus();
    },
    setChangeDate(newData) {
      this.changeData = newData;
    },
    // **********************************************
    // フィルター利用確認
    // **********************************************
    checkFilterUsed() {
      this.showCount = true;
      this.totalCount = this.allData.length;
      if (this.totalCount == 0) {
        this.noDataPrompt = true;
      } else {
        this.noDataPrompt = false;
      }

      if (
        !this.searchKey &&
        this.monthSelected == 0 &&
        this.mainPersonSelected == 0 &&
        !this.isFilterUsed
      ) {
        this.showSelectCount = false;
      } else {
        this.showSelectCount = true;
        this.selectCount = this.filteredBusinessOperatorInfo.length;
        if (this.selectCount == 0) {
          this.noDataPrompt = true;
        }
      }
    },
    SearchBtn(filterParam) {
      this.searchKey = filterParam.searchKey;
      this.copyBopDataFilter = filterParam.returnBopDataFilter;
      this.isFilterUsed = filterParam.motoPageHandleShowBtn;

      if (this.copyBopDataFilter.returnCodeKessanDate == 99) {
        this.isMonthDisable = true;
        this.monthSelected = this.copyBopDataFilter.returnCodeKessanDate;
      } else {
        this.isMonthDisable = false;
        this.monthSelected = this.copyBopDataFilter.returnCodeKessanDate;
      }
      if (this.copyBopDataFilter.returnCodePersonInCharge == 99) {
        this.isMainPersonDisable = true;
        this.mainPersonSelected =
          this.copyBopDataFilter.returnCodePersonInCharge;
      } else {
        this.isMainPersonDisable = false;
        this.mainPersonSelected =
          this.copyBopDataFilter.returnCodePersonInCharge;
      }

      //業者コード
      this.bopCodeSelected = this.copyBopDataFilter.businessOperatorCodeOption;
      this.bopCode = this.copyBopDataFilter.businessOperatorCode;
      //事業者名
      this.bopNameSelected = this.copyBopDataFilter.businessOperatorNameOption;
      this.bopName = this.copyBopDataFilter.businessOperatorName;
      //法人個人区分
      this.corporationDivisionSelected =
        this.copyBopDataFilter.businessOperatorType;
      //決算日
      this.detailDuringDateSelected =
        this.copyBopDataFilter.accountClosingOption;
      this.monthStart = this.copyBopDataFilter.accountClosingFromMonth;
      this.dayStart = this.copyBopDataFilter.accountClosingFromDay;
      this.monthEnd = this.copyBopDataFilter.accountClosingToMonth;
      this.dayEnd = this.copyBopDataFilter.accountClosingToDay;
      if (this.detailDuringDateSelected == 3) {
        this.monthSelected = parseInt(this.monthStart);
      }
      //主担当者名
      this.personInChargeOption = this.copyBopDataFilter.personInChargeOption;
      this.personInChargeInput = this.copyBopDataFilter.personInCharge;
      //事業者アカウント
      // this.accountSelected = this.copyBopDataFilter.bopAccountCondition;
      //事業者への機能開放
      this.functionAuthorityConditionSelected =
        this.copyBopDataFilter.functionAuthorityCondition;
      //事業者からの通知先
      // this.notificationDestinationSelected =
      //   this.copyBopDataFilter.notificationFromBopCondition;
      this.handleSetting();
      // フィルター条件の保存
      this.saveFilter();
      this.isFilterShow = false;
    },
    CancelBtn() {
      this.isFilterShow = false;
    },
    handleShowFilter() {
      this.isFilterShow = true;
      this.STDSDC02C01FilterInit.accountClosingMonth = this.monthSelected;
      this.STDSDC02C01FilterInit.managerOption = this.mainPersonSelected;
      this.STDSDC02C01FilterInit.personInCharge = this.mainPersonSelected;
      this.STDSDC02C01FilterInit.personInChargeList =
        this.getPersonInChargeSelectList;
    },

    formatMessage(item) {
      let signinBopUserNameList = "";
      if (item.usageUser !== null) {
        signinBopUserNameList = item.usageUser.name;
      }
      if (item.signinBopUserList.length != 0) {
        signinBopUserNameList =
          signinBopUserNameList +
          item.signinBopUserList.reduce(
            (previousValue, currentValue) =>
              previousValue + "、" + currentValue.name + this.titleBopUsertip,
            ""
          );
        if (item.usageUser == null) {
          signinBopUserNameList = signinBopUserNameList.slice(1);
        }
      }
      let formatMsg = this.titletip + signinBopUserNameList;

      let userKeyName = "";
      let selectedItemLockInfo = this.dataLockInfoList.find(
        (info) => info.businessOperatorID == item.businessOperatorId
      );
      if (selectedItemLockInfo && selectedItemLockInfo.lockUserDivision == 0) {
        userKeyName = selectedItemLockInfo.lockUserName;
      }
      if (selectedItemLockInfo && selectedItemLockInfo.lockUserDivision == 1) {
        userKeyName = selectedItemLockInfo.lockUserName + this.titleBopUsertip;
      }
      if (userKeyName) {
        // signinBopUserNameListに既にuserKeyNameが含まれている場合は追加しない
        const lockUserName = selectedItemLockInfo.lockUserName;
        const isAlreadyIncluded = signinBopUserNameList.includes(lockUserName);

        if (!isAlreadyIncluded) {
          if (signinBopUserNameList) {
            formatMsg = formatMsg + "、" + userKeyName;
          } else {
            formatMsg = formatMsg + userKeyName;
          }
        }
      }

      return formatMsg;
    },

    // **********************************************
    // 郵便番号3桁、所在地　入力チェック
    // **********************************************
    isEmployeeUsageStatusModalShowCheck() {
      // エラー表示の初期化
      // いずれかが入力されているチェック
      // if (!Validation.isOneRequired(this.zipCode1, this.address)) {

      //   this.isEmployeeUsageStatusModalShow = false;
      // } else {
      this.isEmployeeUsageStatusModalShow = true;
      // }
    },

    // **********************************************
    // STDSDC01C12郵便番号キャンセル
    // **********************************************
    cancelSTDSDC01C10() {
      // 遷移チェック：「キャンセル」
      this.isEmployeeUsageStatusModalShow = false;
    },
    // No5事業者機能利用権限(電帳法)の追加対応　設定ボタンをクリック
    handleSettingButtonClick(selectedRow) {
      this.errors = [];
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }

      //事業者アカウント件数チェック(画面)

      if (selectedRow.bopUserCount == 0) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL9067", Common.getMessage("MTCL9067", []))
          );
        }
      }

      // 相関チェック_ロックユーザー確認
      if (
        selectedRow.usageUser != null ||
        selectedRow.signinBopUserList.length !== 0
      ) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError(
              "MTCL1066",
              Common.getMessage("MTCL1066", [])
            )
          );
        }
      }
      if (!this.errors || this.errors.length == 0) {
        this.$cookies.set(
          "businessOperatorId",
          selectedRow.businessOperatorId,
          "0"
        );
        this.$cookies.set(
          "businessOperatorCode",
          selectedRow.businessOperatorCode,
          "0"
        );
        this.$cookies.set(
          "businessOperatorName",
          selectedRow.businessOperatorName,
          "0"
        );
        this.$cookies.set(
          "accountingOfficeName",
          this.accountingOfficeName,
          "0"
        );
        this.$router.push({ name: 'STFMFM02C31' })
      }
    },
    // No5事業者機能利用権限(電帳法)の追加対応ーURL通知ボタンをクリック
    SentMail(selectedRow) {
      this.errors = [];
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }
       // 相関チェック_ロックユーザー確認
      if (
        selectedRow.usageUser != null ||
        selectedRow.signinBopUserList.length !== 0
      ) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError(
              "MTCL1066",
              Common.getMessage("MTCL1066", [])
            )
          );
        }
      }
      if (!this.errors || this.errors.length == 0) {
        this.processDialogue(true);
        let params = {
          businessOperatorId:
            selectedRow.businessOperatorId,
        };
        API_STFMFM02C01_GetMailAddress(params).then((response) => {
          if (response.result == "0000") {
            this.businessOperatorId =
              selectedRow.businessOperatorId;
            this.businessOperatorName =
              selectedRow.businessOperatorName;
            //宛先
            this.mailAddress = "";
            if (response.stfmfM02C01BopDataHeaders[0].addressList != null) {
              for (var item of response.stfmfM02C01BopDataHeaders[0].addressList) {
                this.mailAddress += item;
                this.mailAddress += "\n";
              }
            }
  
            // STFMFM02C30画面表示
            this.STFMFM02C30Modle = {
              isProcessShow: true,
              businessOperatorId: this.businessOperatorId,
              accountingOfficeName: this.accountingOfficeName,
              businessOperatorName: this.businessOperatorName,
              mailAddress: this.mailAddress,
            };
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
          this.processDialogue(false);
        });
      }
    },
    // No5事業者機能利用権限(電帳法)の追加対応ーURLの通知Modalキャンセル 
    cancelSend() {
      this.STFMFM02C30Modle.isProcessShow = false;
    },
    handleTatsuzinImportDialog() {
      //機能利用権限チェック
      this.errors = [];
      // 操作権限の確認
      if (!this.isBopInfoAvailable) {
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1068", Common.getMessage("MTCL1068", []))
          );
        }
      }
      // Cube認証キーを達人Cubeに渡して認証する。

      if (!this.errors || this.errors.length == 0) {
        this.isImportFromTDKModalShow = true;
      }
    },
    cancelSTDSDC02C17() {
      this.isImportFromTDKModalShow = false;
    },

    reloadSTDSDC02C17() {
      this.isImportFromTDKModalShow = false;
      location.reload();
    },
  },
};
</script>
<style scoped>
.table-wrap{
  min-width: 1200px;
}
</style>